'use client'
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
} from '@/components/ui/command/command'
import { Schema } from '@/lib/fetching/schema'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import React from 'react'

interface FormSearchProps {
  schemasGroupedByCategory: Record<string, Schema[]>
  isStaff: boolean
  source_type?: string
  Lg?: string
  Lc?: string
}

const getLink = (
  schema: Schema,
  isStaff: boolean,
  source_type?: string,
  Lg?: string,
  Lc?: string
) => {
  if (schema.formType === 'digital') {
    if (isStaff) {
      return `/forms/${schema.id}`
    }

    const params = new URLSearchParams()
    params.append('redirect', `/forms/${schema.id}`)

    if (Lg) params.append('Lg', Lg)
    if (Lc) params.append('Lc', Lc)
    if (source_type) params.append('source_type', source_type)

    return `/login/prerequisite?formId=${schema.id}`
  }

  if (schema.category === 'Digital Forms') {
    return `/digital-forms/${schema.id}`
  }

  return `/forms/${schema.id}`
}

export const FormSearch = ({
  schemasGroupedByCategory,
  isStaff,
  source_type,
  Lg,
  Lc,
}: FormSearchProps) => {
  const router = useRouter()

  return (
    <Command
      className="group relative w-full overflow-visible rounded-lg border"
      filter={(value, search) => {
        if (value.toLowerCase().includes(search.toLowerCase())) {
          return 1
        }
        return 0
      }}
    >
      <CommandInput placeholder="Search by service/instruction/form name" />
      <CommandList className="absolute top-full z-50 mt-1 hidden w-full rounded-md border bg-white shadow-lg group-focus-within:block">
        <CommandEmpty>No Instruction for Given Search Criteria</CommandEmpty>
        {Object.entries(schemasGroupedByCategory).map(([category, schemas]) => (
          <React.Fragment key={category}>
            <CommandGroup
              key={category}
              heading={category}
              className="capitalize"
            >
              {schemas.map((schema) => (
                <CommandItem
                  key={schema.id}
                  value={schema.name}
                  onSelect={() =>
                    router.push(getLink(schema, isStaff, source_type, Lg, Lc))
                  }
                  data-transaction-name="form-search-options"
                >
                  <Link
                    href={getLink(schema, isStaff, source_type, Lg, Lc)}
                    passHref
                    className="w-full"
                  >
                    {schema.name}
                  </Link>
                </CommandItem>
              ))}
            </CommandGroup>
            <CommandSeparator />
          </React.Fragment>
        ))}
      </CommandList>
    </Command>
  )
}
